module.exports = __webpack_public_path__ + "media/images/menu-4x-56f0cf43fa4249da560b475555c7967f.png";